var exports = {
  "kL": "xdbfd91f1--24526c--container",
  "wA": "xdbfd91f1--24526c--slide_container",
  "u4": "xdbfd91f1--24526c--track",
  "M6": "xdbfd91f1--24526c--slide",
  "h_": "xdbfd91f1--24526c--description",
  "x6": "xdbfd91f1--24526c--button",
  "AA": "xdbfd91f1--24526c--button--left",
  "Bl": "xdbfd91f1--24526c--button--right",
};

module.exports = exports;
